import styled from "styled-components";
import { colors, header, transition } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";
import { Container } from "../../atoms/Container";

export const StyledHeaderTabs = styled.div`
  display: flex;
  background-color: ${(props) => props.backgroundColor || colors.peach};
  z-index: 150;
  position: sticky;
  transition: ${transition.headerMenuBarTransition};
  top: ${(props) => (props.isHeaderShown ? header.desktopHeight : "0px")};

  ${breakpoints.mdDown} {
    top: ${(props) => (props.isHeaderShown ? header.mobileHeight : "0px")};
  }

  ${breakpoints.smDown} {
    top: ${(props) => {
      if (props.isHeaderShown) {
        return props.mobileTop ? props.mobileTop : header.mobileHeight;
      }
      return "0px";
    }};
  }
`;

export const TabBarContainer = styled.div`
  width: 100%;
  margin-left: 0px;
  ${breakpoints.xsDown} {
    margin-left: 0px;
  }
`;

export const StyledContainer = styled(Container)`
  margin-left: -15px;
  ${breakpoints.xsDown} {
    padding-left: 0px;
    padding-right: 0px;
  }
`;

export const GuidesTabBar = styled.div`
  height: 40px;
  display: flex;

  ${breakpoints.xsDown} {
    padding-left: 0;
    padding-right: 0;
    width: 100%;
    height: 40px;
  }

  a:hover::after {
    transform: scaleX(1);
  }

  &:hover > a {
    border-bottom: transparent solid 2px;
  }

  a:hover ~ a {
    border-bottom: transparent solid 2px;
  }

  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  ::-webkit-scrollbar,
  ::-webkit-scrollbar-thumb,
  ::-webkit-scrollbar-track {
    display: none;
  }

  background-color: ${(props) => props.bgColor};
`;

export const GuidesTabRef = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 1;
`;
